module.exports = __webpack_public_path__ + "img/studentSuccess.08817b1b.svg";